<template>
  <div>
    <quiz
      type="event"
      :send="send"
      :get="get"
      :redirect="successRedirect"
    />
  </div>
</template>

<script>
import {ROUTES} from "../../../router";
import quiz from "../common/quiz";
import quizEventAPI from "../../../api/quizEventAPI";
import common from "../../../helpers/common";

export default {
  components: {
    quiz
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      successRedirect: {
        name: 'Event Evaluations',
        params: {
          attendeeId: this.$route.params.attendeeId
        }
      }
    }
  },
  mounted() {
    common.setHeaderText('Event Quiz');
  },
  methods: {
    get() {
      return quizEventAPI.fetch(this.attendeeId);
    },

    send(data) {
      return quizEventAPI.send(this.attendeeId, data);
    },
  }
}
</script>